import { useSeo } from "@/hooks/useSeo";
import { PillLink } from "@/components/common/PillLink";

export default function NotFound() {
  useSeo("Page not found", "This page could not be found.");
  return (
    <section className="container-x flex flex-col items-start gap-6 py-28" data-testid="not-found-page">
      <h1 className="text-5xl sm:text-6xl font-semibold">Hmm, good question.</h1>
      <p className="text-lg text-ink-soft">We couldn't find that page. Let's explore somewhere else.</p>
      <PillLink to="/" variant="lemon" arrow data-testid="not-found-home">Back to home</PillLink>
    </section>
  );
}
